import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import EmailIcon from "@mui/icons-material/Email";
import HomeIcon from "@mui/icons-material/Home";
import Navbar from "./Navbar";
import GetLogo from "./GetLogo";
import { useLanguage } from "./Langs";
import { useLocation } from "react-router-dom";

const Error = () => {
  let [openHelp, setOpenHelp] = React.useState(false);
  let logo = GetLogo();
  const [lang, setLang] = useLanguage();

  const { state } = useLocation();

  let code = (state && state.enteredCode) || ""; //show the code they entered if we get a certain error

  let showCode = code ? (
    <span>
      <div>
        <b>{lang.PleaseReview}</b>
      </div>
      <span>{code}</span>
    </span>
  ) : (
    ""
  );

  return (
    <div>
      <Navbar
        lang={[lang, setLang]}
        disableToolBar
        openHelp={openHelp}
        setOpenHelp={setOpenHelp}
        color={logo.color}
        helpColor={logo.helpColor}
        banner={logo.banner}
      ></Navbar>

      <div
        className="container404"
        style={{
          textAlign: "center",
          margin: "0 auto",
          marginTop: "100px",
          maxWidth: "800px",
          backgroundColor: "white",
          border: "black 1px solid",
          height: "auto",
          padding: "0",
          borderColor: "transparent",
          boxShadow: "10px 10px 5px rgba(1, 1, 1, 0.5)",
          borderRadius: "20px",
        }}
      >
        <div className="col-md-12">
          <div
            className="error-template"
            style={{
              textAlign: "center",
            }}
          >
            <p
              style={{
                fontSize: "48px",
                fontWeight: "bold",
                textAlign: "center",
                margin: "20px",
              }}
            >
              {lang.Oops}
            </p>
            <hr
              style={{
                width: "50%",
                margin: "0 auto",
                marginBottom: "20px",
                display: "block",
              }}
            ></hr>
            <h2 style={{ textAlign: "center" }}>{lang.InvalidCode}</h2>
            {showCode}
            <div
              className="error-details"
              style={{ marginBottom: "20px", marginTop: "20px" }}
            >
              <b>{lang.SorryCode}</b>
            </div>
            <div className="error-actions">
              <a
                href={`/access/${logo.logo}`}
                className="btn btn-primary btn-lg"
                style={{ marginRight: "10px" }}
              >
                <span className="glyphicon glyphicon-home">
                  <HomeIcon></HomeIcon>
                </span>
                {lang.TakeMeHome}{" "}
              </a>
              <a
                href="mailto:info@myshs.com"
                className="btn btn-default btn-lg"
                style={{ border: "1px solid black", borderRadius: "5px" }}
              >
                <span className="glyphicon glyphicon-envelope">
                  <EmailIcon></EmailIcon>
                </span>{" "}
                {lang.ContactSupport}{" "}
              </a>
            </div>
          </div>
        </div>
        <p style={{ textAlign: "center", margin: "50px", marginTop: "40px" }}>
          {lang.Experience}: <br></br>
          <a href="mailto:info@myshs.com">info@myshs.com</a>
        </p>
      </div>
    </div>
  );
};
export default Error;
